// extracted by mini-css-extract-plugin
export default {"form":"CheckoutSelector-module__form___1Kp7k"};